import { Grid, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";

import type { SummaryPlace } from "../../../../../../../../api/types/svTypes.ts";

interface Props {
  value: SummaryPlace;
  disabled?: boolean;
  onChange: (newValue: SummaryPlace) => void;
}

export const GroupSummaryPlace = ({ value, disabled, onChange }: Props) => {
  return (
    <Grid container sx={{ alignItems: "center", width: "100%" }}>
      <Typography sx={{ color: (theme) => (disabled ? theme.palette.text.disabled : theme.palette.text.primary) }}>
        Show Subtotals at
      </Typography>
      <HorizontalFill />
      <ToggleButtonGroup
        exclusive
        color={"primary"}
        value={value || "Footer"}
        disabled={disabled}
        onChange={(_, value: SummaryPlace | null) => {
          if (value !== null) onChange(value);
        }}
      >
        <ToggleButton value="Inline" sx={{ py: 0.3, fontWeight: 400 }}>
          Top
        </ToggleButton>
        <ToggleButton value="Footer" sx={{ py: 0.3, fontWeight: 400 }}>
          Bottom
        </ToggleButton>
      </ToggleButtonGroup>
    </Grid>
  );
};

export default GroupSummaryPlace;
